import { AlertDialog, DialogContainer } from '@adobe/react-spectrum';
import { error } from '@react/react-spectrum/Toast/js/ToastContainer';
import React, { useEffect, useState } from 'react';

import { commonApi, handleApiCall } from '@exchange-frontends/api';
import { useIMS } from '@exchange-frontends/custom-hooks';

import parseHTML from '../../../utils/ParseHTML';
import HelpSupportGridListItem from './HelpSupportGridListItem';

const TrialInfo = ({ label, icon, loading, trialInfo, description }) => {
  const ims = useIMS();
  const hasTrial = trialInfo?.linkedAppId;
  const appId = trialInfo?.isTrial ? null : trialInfo?.linkedAppId;

  const [trialDesc, setTrialDesc] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  /* GET TRIAL APP DESCRIPTION */
  useEffect(() => {
    if (hasTrial && appId) {
      let mounted = true;
      const handler = handleApiCall(commonApi.ccesV3Extensions, {
        appId: appId,
        resultType: 'details',
        authToken: !ims?.isMock ? ims?.getAccessToken()?.token : undefined,
      });
      handler
        .run()
        .then((data) => {
          const pluginDetails = data?.apps[0];
          if (mounted) {
            setTrialDesc(pluginDetails?.description);
          }
        })
        .catch((err) => {
          // CCES asked us to redirect to login on 429
          if (err.code === 429) {
            if (!ims?.isMock) {
              ims.signIn();
            } else {
              error('You need to login in order to continue', { timeout: 0 });
            }
            // 20 is the error code for aborted requests
          } else if (err.code !== 20) {
            error(err.userMessage, { timeout: 0 });
            console.error(err);
          }
        });
      return () => {
        mounted = false;
        if (handler) {
          handler.controller.abort();
        }
      };
    } else {
      setTrialDesc(description);
    }
  }, [trialInfo?.linkedAppId, hasTrial, appId, description]);

  return (
    <>
      <HelpSupportGridListItem
        onClick={() => setIsDialogOpen(true)}
        icon={icon}
        label={label}
        loading={loading}
        dataLaunchId="Help and Support : Trial info"
      />
      <DialogContainer onDismiss={() => setIsDialogOpen(false)}>
        {isDialogOpen && (
          <AlertDialog title={label} variant="information" primaryActionLabel="Close">
            {parseHTML(trialDesc)}
          </AlertDialog>
        )}
      </DialogContainer>
    </>
  );
};

export default TrialInfo;
